// extracted by mini-css-extract-plugin
module.exports = {"viewport":"BrandStrip_viewport__124gp","track":"BrandStrip_track__JMvfW","brandstrip-scroll":"BrandStrip_brandstrip-scroll__60peb","group":"BrandStrip_group__I4Mup"};